import React, { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import styled from "styled-components";
import PropTypes from "prop-types";

import { getConfig } from "../../../utils/config";

const config = getConfig();
const hideGoogleRecaptcha = config && config.features && config.features.hideGoogleRecaptcha;

const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  scale: 0.8;
  margin-top: 20px;
  margin-bottom: 20px;
`;

/**
 * Google reCAPTCHA wrapper component for Design System.
 */
function GoogleReCAPTCHA({ onChange, sitekey = "6LdfmIUlAAAAAJUK2xhCmFq0YwpvelFOLAXSFuHw" }) {
  const isHidden = hideGoogleRecaptcha;

  useEffect(() => {
    if (isHidden && onChange) {
      onChange(true);
    }
  }, [isHidden, onChange]);

  const handleChange = (value) => (onChange ? onChange(!!value) : null);
  const handleExpire = () => (onChange ? onChange(false) : null);

  if (hideGoogleRecaptcha) {
    return null;
  }

  return (
    <CenteredDiv>
      <ReCAPTCHA
        sitekey={sitekey}
        onChange={handleChange}
        onExpired={handleExpire}
        onErrored={handleExpire}
      />
    </CenteredDiv>
  );
}

GoogleReCAPTCHA.propTypes = {
  onChange: PropTypes.func,
  sitekey: PropTypes.string,
};

export default GoogleReCAPTCHA;



// WEBPACK FOOTER //
// ./src/design-system/atoms/GoogleReCAPTCHA/GoogleReCAPTCHA.jsx